import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
      --primary: #3563E9;
      --primary-dark: #2748b8;
      --secondary: #54A6FF;
      --light: #F6F7F9;
      --dark: #1A202C;
      --gray: #90A3BF;
      --success: #4CAF50;
      --danger: #ED3F3F;
      --font-primary: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
    
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    body {
      font-family: var(--font-primary);
      color: var(--dark);
      background-color: #FCFCFC;
      line-height: 1.6;
    }
    
    a {
      text-decoration: none;
      color: inherit;
    }
    
    ul {
      list-style: none;
    }
    
    .container {
      width: 100%;
      max-width: 1240px;
      margin: 0 auto;
      padding: 0 20px;
    }
    
    /* Button styles */
    .btn {
      display: inline-block;
      padding: 12px 20px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;
    }
    
    .btn-primary {
      background-color: var(--primary);
      color: white;
        border: none;
    }
    
    .btn-primary:hover {
      background-color: var(--primary-dark);
    }
    
    .btn-outline {
      background-color: transparent;
      color: var(--primary);
      border: 2px solid var(--primary);
    }
    
    .btn-outline:hover {
      background-color: var(--primary);
      color: white;
    }


  @media (max-width: 768px) {
    .container {
      padding: 10px;
    }
  }
  
  .faq {
  margin-top: 20px;
}

.faq-item {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}

.filters input,
.filters select,
.filters button {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.car-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
}

.car-card {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  text-align: center;
}

/* Media queries for responsiveness */
    @media (max-width: 992px) {
      .hero h1 {
        font-size: 40px;
      }
      
      .search-grid {
        grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
      }
    }
    
    @media (max-width: 768px) {
      .nav-menu, .auth-buttons {
        display: none;
      }
      
      .mobile-menu-btn {
        display: block;
      }
      
      .hero h1 {
        font-size: 32px;
      }
      
      .hero {
        padding: 60px 0;
      }
      
      .section-title {
        font-size: 28px;
      }
      
      .search-form {
        padding: 20px;
      }
      
      .search-grid {
        grid-template-columns: 1fr;
      }
    }
    
    @media (max-width: 576px) {
      .hero h1 {
        font-size: 28px;
      }
      
      .hero p {
        font-size: 16px;
      }
      
      .hero {
        padding: 40px 0;
      }
      
      .section-title {
        font-size: 24px;
      }
      
      .cta h2 {
        font-size: 28px;
      }
      
      .feature-card, .testimonial-card {
        padding: 20px;
      }
    }
    
    /* Mobile menu */
    .mobile-menu {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      width: 80%;
      max-width: 300px;
      background-color: white;
      z-index: 1001;
      padding: 60px 20px;
      transform: translateX(100%);
      transition: transform 0.3s ease;
      box-shadow: -2px 0 12px rgba(0, 0, 0, 0.1);
    }
    
    .mobile-menu.active {
      transform: translateX(0);
    }
    
    .mobile-menu-close {
      position: absolute;
      top: 20px;
      right: 20px;
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
    }
    
    .mobile-nav-menu {
      margin-bottom: 32px;
    }
    
    .mobile-nav-menu li {
      margin-bottom: 16px;
    }
    
    .mobile-nav-link {
      display: block;
      padding: 8px 0;
      font-weight: 500;
      font-size: 18px;
    }
    
    .mobile-auth-buttons .btn {
      display: block;
      width: 100%;
      margin-bottom: 16px;
    }

  
`;
